module.exports = __webpack_public_path__ + "img/profile.924e2783.svg";